// removed by extract-text-webpack-plugin
module.exports = {"container":"Wx1qXh-MraEhr0VdHCZNE","error":"sHTT865vRf5BCtE2FHL6y","icon":"MBa-Th7l_QYYg5m3M1AaO"};


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true,"localIdentName":"[hash:base64]","modules":true,"importLoaders":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2a9e88da","scoped":false,"hasInlineConfig":false}!./~/less-loader/dist/cjs.js?{"sourceMap":true}!./src/components/shared/SearchContacts/SearchMode/SearchComponent.less
// module id = KfHx
// module chunks = 1